export default function FeatureSection() {
  return (
    <section id="features" className="relative py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs md:text-sm font-medium tracking-widest uppercase text-primary-600 mb-3">
            Warum OOPBuy Spreadsheet
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950">
            Dein smarter Einkaufsbegleiter
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto mt-4 leading-relaxed">
            Das OOPBuy Spreadsheet revolutioniert dein Shopping-Erlebnis &ndash; schneller finden, sicherer kaufen, besser sparen.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <div className="group rounded-2xl bg-background-100 border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-300">
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20minimal%20desk%20workspace%20with%20neatly%20organized%20product%20catalog%20cards%20in%20grid%20layout%20on%20pale%20oatmeal%20surface%2C%20soft%20diffused%20natural%20light%2C%20warm%20neutral%20editorial%20photography%2C%20structured%20organized%20aesthetic%2C%20modern%20European%20design%20style&width=640&height=400&seq=feature-organized-v2&orientation=landscape"
                alt="Organisierte Produktlisten"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 md:p-6">
              <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center mb-4">
                <i className="ri-file-list-3-line text-primary-600 text-lg"></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-2">
                Organisierte Produktlisten
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                Strukturierte Spreadsheets mit hunderten geprüften Produkten &ndash; sortiert nach Kategorien, Qualität und Preis.
              </p>
            </div>
          </div>

          <div className="group rounded-2xl bg-background-100 border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-300">
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Closeup%20of%20verification%20checklist%20with%20green%20checkmarks%20and%20magnifying%20glass%20on%20soft%20sage%20green%20desk%20surface%2C%20quality%20assurance%20concept%2C%20soft%20natural%20light%2C%20trust%20and%20safety%20editorial%20photography%2C%20clean%20organized%20workspace%2C%20reassurance%20theme&width=640&height=400&seq=feature-safe-v2&orientation=landscape"
                alt="Sicher & Geprüft"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 md:p-6">
              <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-primary-600 text-lg"></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-2">
                Sicher &amp; Geprüft
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                Jedes Produkt wird von der Community getestet. QC-Bilder, Verkäuferbewertungen und Sicherheitshinweise inklusive.
              </p>
            </div>
          </div>

          <div className="group rounded-2xl bg-background-100 border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-300">
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stopwatch%20next%20to%20smartphone%20showing%20fast%20delivery%20notification%20on%20warm%20sand%20beige%20surface%2C%20speed%20and%20efficiency%20concept%2C%20soft%20golden%20hour%20light%2C%20modern%20quick%20commerce%20editorial%20photography%2C%20dynamic%20focused%20atmosphere&width=640&height=400&seq=feature-fast-v2&orientation=landscape"
                alt="Schneller zum besten Deal"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 md:p-6">
              <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center mb-4">
                <i className="ri-rocket-line text-primary-600 text-lg"></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-2">
                Schneller zum besten Deal
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                Statt stundenlang zu suchen, findest du mit dem Spreadsheet in Minuten die besten Angebote &ndash; inklusive Versandkosten-Vergleich.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {[
            { value: '10.000+', label: 'Produkte gelistet' },
            { value: '500+', label: 'Geprüfte Shops' },
            { value: '99%', label: 'Zufriedene Nutzer' },
            { value: '24/7', label: 'Community Support' },
          ].map((stat, idx) => (
            <div key={idx} className="text-center p-4 md:p-6 rounded-2xl bg-background-100 border border-background-200/40">
              <p className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-primary-600">{stat.value}</p>
              <p className="text-xs md:text-sm text-foreground-500 mt-2">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}